import React from 'react';

import { Add as AddIcon } from '@mui/icons-material';
import { Button } from '@mui/material';

import { DetailPageLayout } from 'src/components/common';
import { PeosTablePeoPayrollProvider } from 'src/components/peo';
import { ModalId } from 'src/constants/modals';
import { useFilterStorage } from 'src/hooks/common';
import { usePeosList, usePeosUnderPeoPpListQueryVariables } from 'src/hooks/peo';
import { usePeoPayrollProviderParamId } from 'src/hooks/peoPayrollProvider';
import { useModal } from 'src/hooks/shared';
import { InvitePeoByPeoPpModal } from 'src/modals/peo';
import { TableDataProvider } from 'src/providers/TableDataProvider';

export const PeoPayrollProviderDetailPeosPage: React.FC = () => {
  const peoPayrollProviderId = usePeoPayrollProviderParamId();
  const { openModal } = useModal();
  const { pagination } = useFilterStorage();

  const { queryFilter, sortQueryVariable, paginationQueryVariables } =
    usePeosUnderPeoPpListQueryVariables(peoPayrollProviderId);

  const { peosList, peosCount, loading, refetch } = usePeosList(
    queryFilter,
    sortQueryVariable,
    paginationQueryVariables,
  );

  const refetchData = React.useCallback(async () => {
    await refetch();
    pagination.resetPage();
  }, [pagination, refetch]);

  const openInvitePeoByPeoPpModal = () => {
    openModal(ModalId.InvitePeoByPeoPp);
  };

  return (
    <DetailPageLayout
      titleContent="PEOs"
      topRightContent={
        <Button
          variant="contained"
          size="small"
          startIcon={<AddIcon />}
          loading={loading}
          disabled={loading}
          onClick={openInvitePeoByPeoPpModal}
        >
          New
        </Button>
      }
    >
      <TableDataProvider>
        <PeosTablePeoPayrollProvider
          peosList={peosList}
          peosCount={peosCount}
          loading={loading}
          pagination={pagination}
          onRefresh={refetchData}
          isDetail
        />
        <InvitePeoByPeoPpModal peoPayrollProviderId={peoPayrollProviderId} />
      </TableDataProvider>
    </DetailPageLayout>
  );
};
